/** Copyright © 2013-2022 DataYes, All Rights Reserved. */

import { MenuItem, AntdMenuItems } from './types';

/**
 * 根据权限过滤menu
 * @param list menuList
 * @param privilegeList 权限列表
 */
export function filterMenu(list: MenuItem[], privilegeList: string[]): MenuItem[] {
  return (list || []).reduce<MenuItem[]>((result, current) => {
    const newItem = { ...current };
    const { privilege, children, link } = newItem;
    delete newItem.children; // 防止出现 children: [], 的情况

    if (
      // 不需要权限
      typeof privilege === 'undefined' ||
      // 需要单个权限
      (typeof privilege === 'string' && privilegeList.includes(privilege)) ||
      // 需要多个权限并存
      (Array.isArray(privilege) && privilege.every((one) => privilegeList.includes(one)))
    ) {
      // 递归给子节点判断权限
      if (children && children.length > 0) {
        newItem.children = filterMenu(children, privilegeList);
      }
      // 过滤掉没有link，又没有子节点的元素
      if (link || newItem.children?.length) {
        result.push(newItem);
      }
    }

    return result;
  }, []);
}

/**
 * 把菜单展开铺平
 * @param list
 */
export function flattenMenu(list: MenuItem[]): MenuItem[] {
  return list.reduce<MenuItem[]>((result, current) => {
    const newItem = { ...current };
    const { children } = newItem;
    delete newItem.children;

    result.push(newItem);

    if (children) {
      result.push(...flattenMenu(children));
    }
    return result;
  }, []);
}

/**
 * 获取到达指定key的路径
 * @param list
 * @param key
 */
export function getPath(list: MenuItem[], key: string): string[] {
  for (let i = 0; i < list.length; i += 1) {
    const item = list[i];
    if (item.name === key) return [item.name];
    if (item.children) {
      const path = getPath(item.children, key);
      if (path.length > 0) return [item.name, ...path];
    }
  }
  return [];
}

/**
 * 转换成 antd menu items数据格式
 */
export function formatMenuItem(list: MenuItem[]): AntdMenuItems {
  return (list || []).map(({ name, children }) => ({
    key: name,
    label: name,
    children: children && children.length > 0 ? formatMenuItem(children) : undefined,
  }));
}
